import React from "react";
import { PhoneOutgoing, PhoneMissed } from "lucide-react";
import { convertOTimeToLocation } from "./constant";

const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins > 0 ? `${mins} m ` : ""}${secs} secs`;
};

const CallCard = ({ name, callTime, duration, status }) => {
  const isCompleted = status === "completed";
  return (
    <div className="flex items-start justify-between pt-2">
      <div className="flex items-start gap-2">
        {isCompleted ? (
          <PhoneOutgoing size={20} className="text-green-500 mt-1" />
        ) : (
          <PhoneOutgoing size={20} className="text-red-500 mt-1" />
        )}

        <div>
          <p className="text-sm font-medium text-[#373737]">{name}</p>
          <p
            className={`text-[12px] font-medium ${
              isCompleted ? "text-[#667783]" : "text-red-600"
            }`}
          >
            Outgoing call, {formatDuration(duration)}
          </p>
        </div>
      </div>

      <p className="text-[12px] text-[#667783] text-medium whitespace-nowrap">
        {callTime ? convertOTimeToLocation(callTime) : ""}
      </p>
    </div>
  );
};

export default CallCard;
